import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import notify from 'devextreme/ui/notify';

@Injectable()
export class HelperService {

  constructor() { }

  getErrorMessage(err: HttpErrorResponse): string[] {
    
    var errorMessages: string[] = [];
    if (err.error) {

      ///Following loop is used for catching Business Layer error.
      for (var i = 0; i < err.error.length; i++) {
        errorMessages.push("* " + err.error[i].Id + ": " + err.error[i].Message)
      }

      /// Following loop is used for catching ModalState Error.
      for (var key in err.error.ModelState) {
        for (var i = 0; i < err.error.ModelState[key].length; i++) {
          errorMessages.push("* " + err.error.ModelState[key][i]);
        }
      }
    }

    return errorMessages;
  }
  showSuccessMessage(msg:string){
   
    notify({
      message: msg,
      position: {
        my: "center top",
        at: "center top"
      }
    }, "success", 3000);

  }
  showErrorMessage(msg:string){
    notify({
      message: msg,
      position: {
        my: "center top",
        at: "center top"
      }
    }, "delete", 2000);

  }
  showWarningMessage(msg:string){
    notify({
      message: msg,
      position: {
        my: "center top",
        at: "center top"
      }
    }, "Warning", 2000);

  }
}
